<template>
  <div class="admin-media__wrapper custom-scroll-bar-2">
    <vue-element-loading :active="isLoading" spinner="bar-fade-scale" />
    <div class="admin-media__toolbar">
      <input
        ref="fileInput"
        type="file"
        class="admin-media__file-input"
        accept=".apk,.aab,.zip,.pdf,.jpg,.jpeg,.png,.svg,.mp4,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
        @change="onFileSelected"
      />
      <button class="btn-upload cursor-pointer" :disabled="isUploading" @click="openFilePicker">
        <md-icon>cloud_upload</md-icon>
        {{ isUploading ? 'Đang upload...' : 'Upload file' }}
      </button>
    </div>

    <div class="admin-media__table-wrap">
      <table class="ml-member-tbl admin-media__table">
        <thead>
          <tr>
            <th class="text-400-semibold ml-table-cell">Tên file</th>
            <th class="text-400-semibold ml-table-cell w_min_120">Định dạng</th>
            <th class="text-400-semibold ml-table-cell w_min_120">Dung lượng</th>
            <th class="text-400-semibold ml-table-cell w_min_160">Người upload</th>
            <th class="text-400-semibold ml-table-cell w_min_160">Thời gian</th>
            <th class="text-400-semibold ml-table-cell w_min_160">Thao tác</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!mediaList.length && !isLoading">
            <td colspan="6" class="text-center text-400-default admin-media__empty">
              Chưa có file nào. Nhấn Upload file để thêm (ví dụ file .apk).
            </td>
          </tr>
          <tr v-for="item in mediaList" :key="item.id">
            <td class="text-400-medium ml-table-cell">
              <span class="text-2-line" :title="item.filename">{{ item.filename }}</span>
            </td>
            <td class="text-400-medium ml-table-cell">{{ (item.extension || '').toUpperCase() }}</td>
            <td class="text-400-medium ml-table-cell">{{ bytesToSize(item.file_size) }}</td>
            <td class="text-400-medium ml-table-cell">
              {{ item.uploaded_by ? item.uploaded_by.fullname : '-' }}
            </td>
            <td class="text-400-medium ml-table-cell">{{ formatDate(item.created_at) }}</td>
            <td class="text-400-medium ml-table-cell admin-media__actions">
              <button
                class="btn-action btn-copy cursor-pointer"
                v-clipboard:copy="item.download_url"
                v-clipboard:success="onCopySuccess"
                title="Copy link download"
              >
                Copy link
              </button>
              <button class="btn-action btn-delete cursor-pointer" @click="deleteMedia(item)">
                Xóa
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <pagination-template
      v-if="pagination.lastPage > 1"
      class="admin-media__pagination"
      :params="pagination"
      @change-params="changePage"
    />
  </div>
</template>

<script>
import AdminMediaService from "../../../../store/services/AdminMediaService";
import PaginationTemplate from "../../../Components/PaginationTemplate";
import helpers from "../../../../helper/helpers";

export default {
  name: "AdminMedia",

  components: {
    PaginationTemplate,
  },

  data() {
    return {
      mediaList: [],
      isLoading: false,
      isUploading: false,
      pagination: {
        page: 1,
        perPage: 20,
        lastPage: 1,
        total: 0,
      },
    };
  },

  created() {
    this.fetchMedia();
  },

  methods: {
    bytesToSize(size) {
      return helpers.bytesToSize(size);
    },

    formatDate(value) {
      if (!value) return "-";
      const date = new Date(String(value).replace(" ", "T"));
      if (Number.isNaN(date.getTime())) return value;
      return date.toLocaleString("vi-VN");
    },

    openFilePicker() {
      if (this.isUploading) return;
      this.$refs.fileInput.click();
    },

    async onFileSelected(event) {
      const file = event.target.files && event.target.files[0];
      event.target.value = "";
      if (!file) return;

      this.isUploading = true;
      try {
        const formData = new FormData();
        formData.append("file", file);
        const res = await AdminMediaService.upload(formData);
        if (res && res.status !== false && res.data) {
          const uploaded = res.data;
          if (this.pagination.page === 1) {
            this.mediaList.unshift(uploaded);
            if (this.mediaList.length > this.pagination.perPage) {
              this.mediaList.pop();
            }
          } else {
            this.pagination.page = 1;
            await this.fetchMedia();
          }
          this.$notify({
            type: "success",
            text: "Upload file thành công",
          });
        }
      } catch (e) {
        this.$notify({
          type: "error",
          text: "Upload file thất bại",
        });
      } finally {
        this.isUploading = false;
      }
    },

    async fetchMedia() {
      this.isLoading = true;
      try {
        const res = await AdminMediaService.list({
          page: this.pagination.page,
          per_page: this.pagination.perPage,
        });
        if (!res || res.status === false) {
          this.mediaList = [];
          if (res && res.message) {
            this.$notify({ type: 'error', text: res.message });
          }
          return;
        }
        const payload = res.data || {};
        this.mediaList = Array.isArray(payload.items) ? payload.items : [];
        const paging = payload.pagination || {};
        this.pagination.lastPage = paging.last_page || 1;
        this.pagination.total = paging.total || this.mediaList.length;
      } catch (e) {
        this.mediaList = [];
        this.$notify({
          type: 'error',
          text: 'Không thể tải danh sách file',
        });
      } finally {
        this.isLoading = false;
      }
    },

    changePage(params) {
      this.pagination.page = params.page;
      this.pagination.perPage = params.perPage;
      this.fetchMedia();
    },

    onCopySuccess() {
      this.$notify({
        type: "success",
        text: "Đã copy link download",
      });
    },

    deleteMedia(item) {
      this.$modal.show("dialog", {
        title: "Xóa file",
        text: `Bạn có chắc chắn muốn xóa "${item.filename}"?`,
        buttons: [
          {
            title: "Không",
            handler: () => {
              this.$modal.hide("dialog");
            },
          },
          {
            title: "Đồng ý",
            handler: async () => {
              this.$modal.hide("dialog");
              const res = await AdminMediaService.remove(item.id);
              if (res && res.status !== false) {
                this.mediaList = this.mediaList.filter((row) => row.id !== item.id);
                this.$notify({
                  type: "success",
                  text: "Đã xóa file",
                });
              }
            },
          },
        ],
      });
    },
  },
};
</script>

<style lang="scss">
.admin-media__wrapper {
  height: 100%;
  padding: 25px;
  position: relative;

  .admin-media__toolbar {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
  }

  .admin-media__file-input {
    display: none;
  }

  .btn-upload {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: #376bfb;
    border: none;
    border-radius: 4px;
    color: #fff;
    padding: 8px 16px;
    font-size: 14px;

    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
    }
  }

  .admin-media__table-wrap {
    height: calc(100% - 90px);
    overflow: auto;
  }

  .admin-media__empty {
    padding: 40px 16px;
    color: #8a8a8a;
  }

  .admin-media__actions {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }

  .btn-action {
    border: 1px solid #d9d9d9;
    background: #fff;
    border-radius: 4px;
    padding: 4px 10px;
    font-size: 13px;
  }

  .btn-copy {
    color: #376bfb;
    border-color: #376bfb;
  }

  .btn-delete {
    color: #e53935;
    border-color: #ffcdd2;
  }

  .admin-media__pagination {
    margin-top: 16px;
  }
}
</style>
